import { render, staticRenderFns } from "./ProductIntroRes.vue?vue&type=template&id=f0be7444&scoped=true&"
import script from "./ProductIntroRes.vue?vue&type=script&lang=js&"
export * from "./ProductIntroRes.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroRes.vue?vue&type=style&index=0&id=f0be7444&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0be7444",
  null
  
)

export default component.exports